import create from "zustand";
import zukeeper from "zukeeper";
import AssetMetricsReadDto from "../Models/Dashboard/AssetMetricsReadDto";

export type AssetsDashboardListOrderByField =
  | "Compliance"
  | "Connectivity"
  | "Name"
  | "Model";
export type AssetsDashboardListOrderByDirection = "asc" | "desc";
export type AssetsDashboardListOrderByEntry = {
  field: AssetsDashboardListOrderByField;
  direction: AssetsDashboardListOrderByDirection;
};

export const ASSETS_DASHBOARD_DEFAULT_COMPLIANCE_VALUES = [
  "Compliant",
  "NonCompliant",
  "PartiallyCompliant",
  "Unknown",
] as const;

export const ASSETS_DASHBOARD_DEFAULT_CONNECTIVITY_VALUES = [
  "Online",
  "Offline",
  "Partial",
] as const;

const defaultAssetsListOrderBy: AssetsDashboardListOrderByEntry[] = [
  { field: "Name", direction: "asc" },
];

interface IAssetStore {
  selectedAsset: any;
  isTileViewSelected: boolean;
  cachedAssetsData: AssetMetricsReadDto[] | null;
  assetsListSearchText: string;
  assetsListComplianceValues: string[];
  assetsListConnectivityValues: string[];
  assetsListOrderBy: AssetsDashboardListOrderByEntry[];
  setSelectedAsset: (asset: any) => void;
  setIsTileViewSelected: (isSelected: boolean) => void;
  setCachedAssetsData: (data: AssetMetricsReadDto[] | null) => void;
  setAssetsListSearchText: (value: string) => void;
  setAssetsListComplianceValues: (values: string[]) => void;
  setAssetsListConnectivityValues: (values: string[]) => void;
  setAssetsListOrderBy: (
    value:
      | AssetsDashboardListOrderByEntry[]
      | ((
          prev: AssetsDashboardListOrderByEntry[],
        ) => AssetsDashboardListOrderByEntry[]),
  ) => void;
  resetAssetsListFilters: () => void;
}

const useAssetStore = create<IAssetStore>(zukeeper((set) => ({
  selectedAsset: null,
  isTileViewSelected: true,
  cachedAssetsData: null,
  assetsListSearchText: "",
  assetsListComplianceValues: [...ASSETS_DASHBOARD_DEFAULT_COMPLIANCE_VALUES],
  assetsListConnectivityValues: [...ASSETS_DASHBOARD_DEFAULT_CONNECTIVITY_VALUES],
  assetsListOrderBy: defaultAssetsListOrderBy,
  setSelectedAsset: (asset: any) => {
    set(() => {
      return {
        selectedAsset: asset,
      };
    });
  },
  setIsTileViewSelected: (isSelected: boolean) => {
    set(() => {
      return {
        isTileViewSelected: isSelected,
      };
    });
  },
  setCachedAssetsData: (data: AssetMetricsReadDto[] | null) => {
    set(() => {
      return {
        cachedAssetsData: data,
      };
    });
  },
  setAssetsListSearchText: (value: string) => {
    set(() => ({ assetsListSearchText: value }));
  },
  setAssetsListComplianceValues: (values: string[]) => {
    set(() => ({ assetsListComplianceValues: values }));
  },
  setAssetsListConnectivityValues: (values: string[]) => {
    set(() => ({ assetsListConnectivityValues: values }));
  },
  setAssetsListOrderBy: (value) => {
    set((state) => ({
      assetsListOrderBy:
        typeof value === "function" ? value(state.assetsListOrderBy) : value,
    }));
  },
  resetAssetsListFilters: () => {
    set(() => ({
      assetsListSearchText: "",
      assetsListComplianceValues: [...ASSETS_DASHBOARD_DEFAULT_COMPLIANCE_VALUES],
      assetsListConnectivityValues: [
        ...ASSETS_DASHBOARD_DEFAULT_CONNECTIVITY_VALUES,
      ],
      assetsListOrderBy: [...defaultAssetsListOrderBy],
    }));
  },
})));

export default useAssetStore;